import React from "react";
import { Link } from "react-router-dom";

export default function ServicesBox({ SerData }) {
  return (
    <>
      <div className="col col-lg-4 col-xs-6">
        <div className="grid">
          <div className="img-holder">
            <img
              src={SerData.image}
              alt={SerData.image_alt}
              title={SerData.image_title}
              className="img img-responsive"
            />
          </div>
          <div className="details">
            <h3>
              <Link to={`/service/${SerData.slug}`}>{SerData.title}</Link>

              {/* <i className="fi flaticon-money-2"></i> */}
              {/* <i className={SerData.icon}></i> */}
              {/* to={`/service/${SerData.slug}`} */}
            </h3>
            <p>{SerData.tagline}</p>
            <Link
              to={`/service/${SerData.slug}`}
              className="link-btn"
              rel="noreferrer"
              aria-label="All Service Details"
            >
              read more{" "}
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
